/**
* Services Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Services Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'services-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.services-slider__splide' ).length ) {
        $( '.services-slider__splide' ).each( function( index, element ) {
          const slider = new Splide( $( element )[0], {
            perPage: 3,
            pagination: false,
            gap: '2rem',
            speed: 800,
            rewind: true,
            breakpoints: {
              767: {
                perPage: 1,
              },
            },
          } );

          const bar = slider.root.querySelector( '.progress-bar' );

          slider.on( 'mounted move', function() {
            const end = slider.Components.Controller.getEnd() + 1;
            const rate = Math.min( ( slider.index + 1 ) / end, 1 );
            bar.style.width = String( 100 * rate ) + '%';
          } );

          slider.mount( );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'services-slider', COMPONENT );
} )( app );
